/* global window */

import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, browserHistory as history, Switch, Redirect } from 'react-router-dom';
import '../../styles/core.scss';
import BasicApp from './basic-app';
import ConnectedOverview from '../overview/overview';
import ConnectedClassDetails from '../class-details/class-details';
import ConnectedBusyIndicator from '../../components/busy-indicator/busy-indicator';
import ConnectedModalContainer from '../../components/modal/modal-container';
import ConnectedParticipationReport from '../participation-report/participation-report';
import ConnectedCertificates from '../certificates/certificates';
import ConnectedToastContainer from '../../components/toast/toast-container';

export default class EntryApp extends BasicApp {
    render(store) {
        // When executing on demo, QA, or production, the host app will inject a property
        // called pppAppConfig into the global window variable.  This will provide the
        // base name of the app.  Most of the time that will be an empty string, but in
        // case it is not, we will extract it and pass it to the router, below.

        // eslint-disable-next-line no-underscore-dangle
        const appConfig = window._env_;
        const BASE_NAME = appConfig ? appConfig.BaseName : '';

        return (
            <Provider store={store}>
                <Router history={history} basename={BASE_NAME}>
                    <div>
                        <ConnectedBusyIndicator />
                        <Switch>
                            <Route exact path="/home" component={ConnectedOverview} />
                            <Route exact path="/class-details" component={ConnectedClassDetails} />
                            <Route exact path="/participation-report" component={ConnectedParticipationReport} />
                            <Route exact path="/certificates" component={ConnectedCertificates} />
                            <Redirect exact from="*" to="/home" />
                        </Switch>
                        <ConnectedModalContainer />
                        <ConnectedToastContainer />
                    </div>
                </Router>
            </Provider>
        );
    }
}

window.EntryApp = EntryApp;



// WEBPACK FOOTER //
// ./containers/app/entry-app.js